<template>
  <section>
    <el-card shadow="never">
      <div class="top-bar">
        <el-input
          placeholder="输入商品名称查询"
          v-model="searchKey"
          @change="search()"
          style="width: 210px; margin-right: 20px"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="classId"
          @change="searchClass()"
          placeholder="主题分类查询"
          style="margin-right: 25px"
          clearable
        >
          <el-option
            v-for="(it, index) in classify"
            :key="index"
            :value="it.id"
            :label="it.title"
          ></el-option>
        </el-select>
      </div>
      <el-table
        :data="tableData"
        max-height="500"
        ref="table"
        style="width: 100%"
      >
        <el-table-column
          prop="barcode"
          label="条形码"
          align="center"
        ></el-table-column>
         <el-table-column
          prop="attr_symbol_string"
          label="规格名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="商品图片" align="center">
          <template slot-scope="scope">
            <m-img v-if="scope.row.sku_pic_url" :src="scope.row.sku_pic_url" />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="total_price" align="center" label="商品价格">
          <template slot-scope="scope">
            <span v-if="scope.row.min_price == scope.row.max_price">C${{scope.row.min_price}}</span>
            <span v-else>C${{ (scope.row.min_price*1).toFixed(2) }} ~ C${{(scope.row.max_price *1).toFixed(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" align="center" label="折扣价格">
          <template slot-scope="scope">
            <span v-if="scope.row.off == 0">--</span>
            <span v-else>
              <span v-if="scope.row.min_price == scope.row.max_price">C${{(scope.row.min_price * scope.row.off / 100).toFixed(2)}}</span>
              <span v-else>
                C${{ (scope.row.min_price * scope.row.off / 100).toFixed(2) }} ~ C${{(scope.row.max_price * scope.row.off / 100).toFixed(2)}}
              </span>
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="编辑" width="400px">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              plain
              @click="delSetRem(scope.row)"
              :disabled="userId == 12 ? false : true"
              >删除规格</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleSetRem(scope.row, 1)"
              >首页推荐</el-button
            >
            <el-button
              size="mini"
              type="danger"
              plain
              @click="handleSetRem(scope.row, 2)"
              >热销推荐</el-button
            >
            <el-button
              size="mini"
              type="warning"
              plain
              @click="handleSetRem(scope.row, 3)"
              >好货推荐</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next,jumper"
        style="padding: 10px"
        :total="total"
        :page-size="size"
        @current-change="loadMore"
      />
    </el-card>
  </section>
</template>


<script>
import { get_pre_sale, set_rem_presale } from "@/api/market.js";
import { classify_list, sku_del } from '@/api/goods.js'
import { userinfo } from '@/api/home.js'
import MImg from "@/components/Image";
export default {
  components: { MImg },
  data() {
    return {
      tableData: [],
      total: 0,
      page: 1,
      size: 50,
      searchKey: "",
      classId: "",
      ids: [], // table 选中数据的 id 数组集合
      id: "", //  有id 是修改  没有id是添加
      sort: 1,
      scrollTop: null,
      userId: ''
    };
  },
  methods: {
    // 主题商品列表
    getData() {
      let params = {
        page: this.page,
      };
      if (this.classId != "") {
        params.type_id = this.classId;
      }
      if (this.searchKey != "") {
        params.search = this.searchKey;
      }
      get_pre_sale(params).then((res) => {
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.size = res.data.per_page
        } else {
          this.tableData = [];
        }
      });
      userinfo().then(res => {
        if(res) {
          this.userId = res.data.id
        }
      })
    },
    search() {
      this.classId = "";
      this.page = 1;
      this.getData();
    },
    searchClass() {
      this.value = "";
      this.page = 1;
      this.getData();
    },

    loadMore(page) {
      this.page = page;
      this.getData();
      this.scrollTop = 0;
      this.saveScroll();
    },
    saveScroll() {
      let scrollTop = this.$el.querySelector(".el-table__body-wrapper");
      scrollTop.scrollTop = this.scrollTop;
    },
    // 获取分类数据
    getClass() {
      let params = {
        level:2
      }
      classify_list(params).then((res) => {
        if (res) {
          this.classify = res.data;
        } else {
          this.classify = [];
        }
      });
    },

    // 监听 table 选中事件，获取选中数据的id
    handleChecked(rows) {
      rows.forEach((e) => {
        this.ids.push(e.id);
      });
    },
    handleSetRem(row, flag) {
      // 设置首页推荐
      set_rem_presale({ goods_id: row.goods_id, flag: flag }).then((res) => {
        if (res) {
          this.$emit("mapId", row.name + flag);
          this.$message({ type: "success", message: res.msg, duration: 1500 });
        }
      });
    },
    delSetRem(row) {
      this.$confirm(`此操作将删除规格, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
          sku_del(row.sku_id).then(res => {  
            if(res){
              this.$message({ type: "success", message: res.msg});
              this.getData();
            }
          })
      }).catch(() => {
                  
      });
    }
  },
  created() {
    this.getData();
    this.getClass();
  },
  activated() {
    this.getData();
    this.saveScroll();
    this.getClass();
  },
  mounted() {
    // 监听滚动条的位置
    this.$refs.table.bodyWrapper.addEventListener(
      "scroll",
      (res) => {
        // let height = res.target;
        this.scrollTop = res.target.scrollTop;
      },
      false
    );
  },
  beforeDestroy() {
    this.$refs.table.bodyWrapper.removeEventListener(
      "scroll",
      (res) => {
        // let height = res.target;
        this.scrollTop = res.target.scrollTop;
      },
      false
    );
  },
};
</script>

<style lang="less" scoped>
section {
  .top-btn {
    width: 80px;
    margin-right: 15px;
  }
  .line-item {
    margin-bottom: 20px;
  }
  .input-left {
    height: 40px;
    line-height: 40px;
  }
}
</style>